import React, { useState, useEffect, useCallback } from "react";
import MobilePopUp from "../../components/MobilePopUp/MobilePopUp";
import { useSelector, useDispatch } from "react-redux";
import DataTable from "../../components/Table";
import // getAllFreezeData,
// freezedateAction,
// freezedateDeleteAction,
"../../store/actions/monthEnd";

const FreezeDates = (props) => {
  const dispatch = useDispatch();
  const [freezeStartDate, setFreezeStartDate] = useState("");
  const [freezeStartTime, setFreezeStartTime] = useState("");
  const [freezeEndDate, setFreezeEndDate] = useState("");
  const [freezeEndTime, setFreezeEndTime] = useState("");
  const [updateFreezeStartDateValue, setUpdateFreezeStartDateValue] =
    useState("");
  const [updateFreezeStartTimeValue, setUpdateFreezeStartTimeValue] =
    useState("");
  const [updateFreezeEndDateValue, setUpdateFreezeEndDateValue] = useState("");
  const [updateFreezeEndTimeValue, setUpdateFreezeEndTimeValue] = useState("");
  const [updateLoginDateValue, setUpdateLoginDateValue] = useState("");
  const [updateLoginTimeValue, setUpdateLoginTimeValue] = useState("");
  const [loginDate, setLoginDate] = useState("");
  const [loginTime, setLoginTime] = useState("");
  const [selection, setSelection] = useState("Login");
  const [minDate, setMinDate] = useState("");
  const [errors, setErrors] = useState({});
  const [isEndDateTimeEnabled, setIsEndDateTimeEnabled] = useState(false);
  const [updateisEndDateTimeEnabled, setupdateIsEndDateTimeEnabled] =
    useState(false);
  const [showEditModal, setshowEditModal] = useState(false);
  const [showDeleteModal, setshowDeleteModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [data, setData] = useState([]);
  const [freezeStartDateTimevalidate, setFreezeStartDateTimevalidate] =
    useState("");
  const [curreFreezingTimeUpdate, setCurreFreezingTimeUpdate] = useState("");


  useEffect(() => {
    // Set the minimum date to today's date
    const today = new Date().toISOString().split("T")[0];
    setMinDate(today);
  }, []);

  useEffect(() => {
    // Set the minimum date for freezeEndDate based on freezeStartDate
    if (freezeStartDate) {
      document
        .getElementById("freezeEndDate")
        .setAttribute("min", freezeStartDate);
    }
  }, [freezeStartDate]);

  useEffect(() => {
    // Enable freezeEndDate and freezeEndTime if both freezeStartDate and freezeStartTime are set
    if (freezeStartDate && freezeStartTime) {
      setIsEndDateTimeEnabled(true);
    } else {
      setIsEndDateTimeEnabled(false);
    }
  }, [freezeStartDate, freezeStartTime]);

  useEffect(() => {
    // Enable freezeEndDate and freezeEndTime if both freezeStartDate and freezeStartTime are set
    if (updateFreezeStartDateValue && updateFreezeStartTimeValue) {
      setupdateIsEndDateTimeEnabled(true);
    } else {
      setupdateIsEndDateTimeEnabled(false);
    }
  }, [updateFreezeStartDateValue, updateFreezeStartTimeValue]);

  useEffect(() => {
    // Auto-fill loginDate with freezeStartDate when freezeStartDate changes
    if (freezeStartDate || freezeStartTime) {
      setLoginDate(freezeStartDate);
    }
  }, [freezeStartDate]);

  useEffect(() => {
    // Auto-fill loginDate with freezeStartDate when freezeStartDate changes
    if (freezeStartTime) {
      setLoginTime(freezeStartTime);
    }
  }, [freezeStartTime]);

  useEffect(() => {
    // Auto-fill loginDate with freezeStartDate when freezeStartDate changes
    if (updateFreezeStartDateValue) {
      setUpdateLoginDateValue(updateFreezeStartDateValue);
    }
  }, [updateFreezeStartDateValue]);

  useEffect(() => {
    // Auto-fill loginDate with freezeStartDate when freezeStartDate changes
    if (updateFreezeStartTimeValue) {
      setUpdateLoginTimeValue(updateFreezeStartTimeValue);
    }
  }, [updateFreezeStartTimeValue]);

  const formatDate = (date) => {
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`;
  };

  // Function to reformat date to YYYY-MM-DD format
  const reformatDateToInputFormat = (dateString) => {
    const [day, month, year] = dateString.split("-");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  };
  const parseDateTime = (date, time) => {
    const [day, month, year] = date.split("-").map(Number);
    const [hours, minutes] = time.split(":").map(Number);
    return new Date(year, month - 1, day, hours, minutes);
  };

  const handleSave = async () => {
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    let validationErrors = {};

    // Check if required fields are empty
    if (!freezeStartDate)
      validationErrors.freezeStartDate = "Freeze Start Date is required";
    if (!freezeStartTime)
      validationErrors.freezeStartTime = "Freeze Start Time is required";
    if (!freezeEndDate)
      validationErrors.freezeEndDate = "Freeze End Date is required";
    if (!freezeEndTime)
      validationErrors.freezeEndTime = "Freeze End Time is required";
    if (!loginDate) validationErrors.loginDate = "Date is required";
    if (!loginTime) validationErrors.loginTime = "Time is required";

    // Set errors and return if there are any
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Clear errors if validation passes
    setErrors({});

    const currentDateTime = new Date();
    const freezeStartDateTime = new Date(
      `${freezeStartDate}T${freezeStartTime}`
    );
    const freezeEndDateTime = new Date(`${freezeEndDate}T${freezeEndTime}`);

    // Check if freezeStartDateTime and freezeEndDateTime are not greater than currentDateTime
    if (
      freezeStartDateTime < currentDateTime ||
      freezeEndDateTime < currentDateTime
    ) {
      validationErrors.global =
        "Freeze Start DateTime and Freeze End DateTime cannot be in the past.";
      setErrors(validationErrors);
      return;
    }

    const diffInTime = freezeEndDateTime - freezeStartDateTime;
    const diffInDays = diffInTime / (1000 * 3600 * 24);

    if (diffInDays > 15) {
      validationErrors.global =
        "The difference between Freeze Start and End dates cannot be greater than 15 days.";
      setErrors(validationErrors);
      setLoginDate(freezeStartDate);
      setLoginTime(freezeStartTime);
      setFreezeEndDate("");
      setFreezeEndTime("");
      return;
    }

    const formattedFreezeStartDateTime = `${formatDate(
      freezeStartDate
    )} ${freezeStartTime}`;
    const formattedFreezeEndDateTime = `${formatDate(
      freezeEndDate
    )} ${freezeEndTime}`;
    const formattedLoginDate = `${formatDate(loginDate)} ${loginTime}`;
    // Validate loginDateTime is between freezeStartDateTime and freezeEndDateTime
    const parFreezeStartDateTime = parseDateTime(
      formatDate(freezeStartDate),
      freezeStartTime
    );
    const parformattedFreezeEndDateTime = parseDateTime(
      formatDate(freezeEndDate),
      freezeEndTime
    );
    const parformattedLoginDate = parseDateTime(
      formatDate(loginDate),
      loginTime
    );

    if (
      parformattedLoginDate < parFreezeStartDateTime ||
      parformattedLoginDate > parformattedFreezeEndDateTime
    ) {
      validationErrors.global =
        "DateTime must be between Freeze Start DateTime and Freeze End DateTime.";
      setErrors(validationErrors);
      return;
    }
    const formData = {
      createdBy: userDetails.user.code,
      //freezeType: selection.toUpperCase(),
      freezeStartDate: formattedFreezeStartDateTime,
      freezeEndDate: formattedFreezeEndDateTime,
      dateValue: formattedFreezeStartDateTime,
    };

    // props.dateFormData(formData)
  };

  useEffect(() => {
    if (freezeStartDate || freezeStartTime || freezeEndDate || freezeEndTime) {
      let formData = {
        freezeStartDate: freezeStartDate,
        freezeStartTime: freezeStartTime,
        freezeEndDate: freezeEndDate,
        freezeEndTime: freezeEndTime,
      };
      props.handleChange(formData);
    }
  }, [freezeStartDate, freezeStartTime, freezeEndDate, freezeEndTime]);

  useEffect(() => {
    if (modalData) {
      // Reformat and set freezeStartDate
      if (modalData.freezeStartDate) {
        const [startDate, startTime] = modalData.freezeStartDate.split(" ");
        setUpdateFreezeStartDateValue(reformatDateToInputFormat(startDate));
        setUpdateFreezeStartTimeValue(startTime);

        const checkCurrentDate = new Date();
        const [day, month, yearTime] = modalData.freezeStartDate.split("-");
        const [monthYear, time] = yearTime.split(" ");
        const [year] = monthYear.split(" ");
        const formattedDateString = `${year}-${month}-${day}T${time}:00`; // Convert to ISO 8601 format
        const freezeStartDateTimevalidate = new Date(formattedDateString);
        setFreezeStartDateTimevalidate(freezeStartDateTimevalidate);
        // Check if freezeStartDateTime and freezeEndDateTime are not greater than currentDateTime
        const setFreezingTimeUpdate =
          checkCurrentDate > freezeStartDateTimevalidate ? true : false;
        setCurreFreezingTimeUpdate(setFreezingTimeUpdate);
      } else {
        console.error("freezeStartDate is undefined or null");
      }

      // Reformat and set freezeEndDate
      if (modalData.freezeEndDate) {
        const [endDate, endTime] = modalData.freezeEndDate.split(" ");
        setUpdateFreezeEndDateValue(reformatDateToInputFormat(endDate));
        setUpdateFreezeEndTimeValue(endTime);
      } else {
        console.error("freezeEndDate is undefined or null");
      }

      // Reformat and set dateValue
      if (modalData.dateValue) {
        setUpdateLoginDateValue(reformatDateToInputFormat(modalData.dateValue));
      } else {
        console.error("dateValue is undefined or null");
      }
    }
  }, [modalData]);

  const updatefreezeData = async () => {
    let validationErrors = {};

    // Check if required fields are empty
    if (!updateFreezeStartDateValue)
      validationErrors.updateFreezeStartDateValue =
        "Freeze Start Date is required";
    if (!updateFreezeStartTimeValue)
      validationErrors.updateFreezeStartTimeValue =
        "Freeze Start Time is required";
    if (!updateFreezeEndDateValue)
      validationErrors.updateFreezeEndDateValue = "Freeze End Date is required";
    if (!updateFreezeEndTimeValue)
      validationErrors.updateFreezeEndTimeValue = "Freeze End Time is required";
    if (!updateLoginDateValue)
      validationErrors.updateLoginDateValue = "Date is required";
    if (!updateLoginTimeValue)
      validationErrors.updateLoginTimeValue = "Time is required";

    // Set errors and return if there are any
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Clear errors if validation passes
    setErrors({});

    const updatecurrentDateTime = new Date();
    const updatefreezeStartDateTime = new Date(
      `${updateFreezeStartDateValue}T${updateFreezeStartTimeValue}`
    );
    const updatefreezeEndDateTime = new Date(
      `${updateFreezeEndDateValue}T${updateFreezeEndTimeValue}`
    );
    if (curreFreezingTimeUpdate) {
      // If CurreFreezingTimeUpdate is true, only check the first condition.
      if (updatefreezeEndDateTime < updatecurrentDateTime) {
        validationErrors.global = "Freeze End DateTime cannot be in the past.";
        setErrors(validationErrors);
        return;
      }
    } else {
      // If CurreFreezingTimeUpdate is false, check both conditions.
      if (
        updatefreezeStartDateTime < updatecurrentDateTime ||
        updatefreezeEndDateTime < updatecurrentDateTime
      ) {
        validationErrors.global =
          "Freeze Start DateTime and Freeze End DateTime cannot be in the past.";
        setErrors(validationErrors);
        return;
      }
    }

    const updatediffInTime =
      updatefreezeEndDateTime - updatefreezeStartDateTime;
    const updatediffInDays = updatediffInTime / (1000 * 3600 * 24);

    if (updatediffInDays > 15) {
      validationErrors.global =
        "The difference between Freeze Start and End dates cannot be greater than 15 days.";
      setErrors(validationErrors);
      setUpdateLoginDateValue(updateFreezeStartDateValue);
      setUpdateLoginTimeValue(updateFreezeStartTimeValue);
      setUpdateFreezeEndDateValue("");
      setUpdateFreezeEndTimeValue("");
      return;
    }

    const updateformattedFreezeStartDateTime = `${formatDate(
      updateFreezeStartDateValue
    )} ${updateFreezeStartTimeValue}`;
    const updateformattedFreezeEndDateTime = `${formatDate(
      updateFreezeEndDateValue
    )} ${updateFreezeEndTimeValue}`;
    const updateformattedLoginDate = `${formatDate(
      updateLoginDateValue
    )} ${updateLoginTimeValue}`;

    // Validate loginDateTime is between freezeStartDateTime and freezeEndDateTime

    const updateformattedFreezeStartDateTimeVal = parseDateTime(
      formatDate(updateFreezeStartDateValue),
      updateFreezeStartTimeValue
    );
    const updateformattedFreezeEndDateTimeVal = parseDateTime(
      formatDate(updateFreezeEndDateValue),
      updateFreezeEndTimeValue
    );
    const updateformattedLoginDateVal = parseDateTime(
      formatDate(updateLoginDateValue),
      updateLoginTimeValue
    );

    if (
      updateformattedLoginDateVal < updateformattedFreezeStartDateTimeVal ||
      updateformattedLoginDateVal > updateformattedFreezeEndDateTimeVal
    ) {
      validationErrors.global =
        "Login DateTime must be between Freeze Start DateTime and Freeze End DateTime.";
      setErrors(validationErrors);
      return;
    }
    const formData = {
      id: modalData.id,
      freezeStartDate: updateformattedFreezeStartDateTime,
      freezeEndDate: updateformattedFreezeEndDateTime,
      dateValue: updateformattedFreezeStartDateTime,
    };
    try {
      // Dispatch the freezeDateAction and wait for it to complete
      await dispatch();
      // freezedateAction(formData, (res) => {
      //   if (res.data.body) {
      //     setshowEditModal(false);
      //     // Clear all input fields
      //     setUpdateFreezeStartDateValue("");
      //     setUpdateFreezeStartTimeValue("");
      //     setUpdateFreezeEndDateValue("");
      //     setUpdateFreezeEndTimeValue("");
      //     setUpdateLoginDateValue("");
      //     setUpdateLoginTimeValue("");
      //     // Dispatch the getAllFreezeData action
      //     // dispatch(
      //     //   getAllFreezeData((response) => {
      //     //     // Set the data in the local state
      //     //     setData(
      //     //       response.body.map((item) => ({
      //     //         id: item.id,
      //     //         createdBy: item.createdBy,
      //     //         //freezeType: item.freezeType,
      //     //         freezeStartDate: item.freezeStartDate,
      //     //         freezeEndDate: item.freezeEndDate,
      //     //         dateValue: item.freezeStartDate,
      //     //       }))
      //     //     );
      //     //   })
      //     // );
      //   }
      // })
    } catch (error) {
      console.error("Error during saving:", error);
      // Handle any errors that might occur during the dispatch
    }
  };

  const deleteData = async (modalData) => {
    try {
      // Dispatch the freezeDateAction and wait for it to complete
      await dispatch();
      // freezedateDeleteAction(modalData, (res) => {
      //   setshowDeleteModal(false);
      //   if (res.data.body === true) {
      //     // Dispatch the getAllFreezeData action
      //     // dispatch(
      //     //   getAllFreezeData((response) => {
      //     //     // Set the data in the local state
      //     //     setData(
      //     //       response.body.map((item) => ({
      //     //         id: item.id,
      //     //         createdBy: item.createdBy,
      //     //         //freezeType: item.freezeType,
      //     //         freezeStartDate: item.freezeStartDate,
      //     //         freezeEndDate: item.freezeEndDate,
      //     //         dateValue: item.freezeStartDate,
      //     //       }))
      //     //     );
      //     //   })
      //     // );
      //   }
      // })
    } catch (error) {
      console.error("Error during saving:", error);
      // Handle any errors that might occur during the dispatch
    }
  };
  const dateInputClassName =
    "tpa-medical-scheduling__input form-control tpa-medical-scheduling__input--date";

  if (props.compact) {
    return (
      <>
        <div className="tpa-medical-scheduling__field">
          <label htmlFor="freezeStartDate" className="tpa-medical-scheduling__label">
            Start date
          </label>
          <input
            type="date"
            id="freezeStartDate"
            className={dateInputClassName}
            value={freezeStartDate}
            onChange={(e) => {
              setFreezeStartDate(e.target.value);
              setErrors((prevErrors) => ({
                ...prevErrors,
                freezeStartDate: "",
              }));
            }}
            min={minDate}
            max={freezeEndDate}
          />
          {errors.freezeStartDate && (
            <div className="text-danger">{errors.freezeStartDate}</div>
          )}
        </div>

        <div className="tpa-medical-scheduling__field">
          <label htmlFor="freezeStartTime" className="tpa-medical-scheduling__label">
            Start time
          </label>
          <input
            type="time"
            id="freezeStartTime"
            className={dateInputClassName}
            value={freezeStartTime}
            onChange={(e) => {
              setFreezeStartTime(e.target.value);
              setErrors((prevErrors) => ({
                ...prevErrors,
                freezeStartTime: "",
              }));
            }}
          />
          {errors.freezeStartTime && (
            <div className="text-danger">{errors.freezeStartTime}</div>
          )}
        </div>

        <div className="tpa-medical-scheduling__field">
          <label htmlFor="freezeEndDate" className="tpa-medical-scheduling__label">
            End date
          </label>
          <input
            type="date"
            id="freezeEndDate"
            className={dateInputClassName}
            value={freezeEndDate}
            onChange={(e) => {
              setFreezeEndDate(e.target.value);
              setErrors((prevErrors) => ({
                ...prevErrors,
                freezeEndDate: "",
              }));
            }}
            min={freezeStartDate || minDate}
            disabled={!isEndDateTimeEnabled}
          />
          {errors.freezeEndDate && (
            <div className="text-danger">{errors.freezeEndDate}</div>
          )}
        </div>

        <div className="tpa-medical-scheduling__field">
          <label htmlFor="freezeEndTime" className="tpa-medical-scheduling__label">
            End time
          </label>
          <input
            type="time"
            id="freezeEndTime"
            className={dateInputClassName}
            value={freezeEndTime}
            onChange={(e) => {
              setFreezeEndTime(e.target.value);
              setErrors((prevErrors) => ({
                ...prevErrors,
                freezeEndTime: "",
              }));
            }}
            disabled={!isEndDateTimeEnabled}
          />
          {errors.freezeEndTime && (
            <div className="text-danger">{errors.freezeEndTime}</div>
          )}
        </div>
      </>
    );
  }

  // console.log('freezeStartDate',freezeStartDate,'freezeStartTime',freezeStartTime,'freezeEndDate',freezeEndDate,'freezeEndTime',freezeEndTime)
  return (
    <>
      <div className="freeze-main-wrapper">
        <div className="tpa_waive_container">
          <div className="freezeDatesWrapp">
            <form className="createForm">
              <div className="row">
                <div className="mb-3 col-lg-4 col-8">
                  <label htmlFor="freezeStartDate" className="form-label">
                    Start Date
                  </label>
                  <input
                    type="date"
                    id="freezeStartDate"
                    className="form-control"
                    value={freezeStartDate}
                    onChange={(e) => {
                      setFreezeStartDate(e.target.value);
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        freezeStartDate: "",
                      }));
                    }}
                    min={minDate}
                    max={freezeEndDate}
                  />
                  {errors.freezeStartDate && (
                    <div className="text-danger">{errors.freezeStartDate}</div>
                  )}
                </div>

                <div className="mb-3 col-lg-2 col-4">
                  <div className="hideLable">hide</div>
                  <input
                    type="time"
                    id="freezeStartTime"
                    className="form-control"
                    value={freezeStartTime}
                    onChange={(e) => {
                      setFreezeStartTime(e.target.value);
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        freezeStartTime: "",
                      }));
                    }}
                  />
                  {errors.freezeStartTime && (
                    <div className="text-danger">{errors.freezeStartTime}</div>
                  )}
                </div>

                <div className="mb-3 col-8 col-lg-4">
                  <label htmlFor="freezeEndDate" className="form-label">
                    End Date
                  </label>
                  <input
                    type="date"
                    id="freezeEndDate"
                    className="form-control"
                    value={freezeEndDate}
                    onChange={(e) => {
                      setFreezeEndDate(e.target.value);
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        freezeEndDate: "",
                      }));
                    }}
                    min={freezeStartDate || minDate}
                    disabled={!isEndDateTimeEnabled}
                  />
                  {errors.freezeEndDate && (
                    <div className="text-danger">{errors.freezeEndDate}</div>
                  )}
                </div>

                <div className="mb-3 col-4 col-lg-2">
                  <div className="hideLable">hide</div>
                  <input
                    type="time"
                    id="freezeEndTime"
                    className="form-control"
                    value={freezeEndTime}
                    onChange={(e) => {
                      setFreezeEndTime(e.target.value);
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        freezeEndTime: "",
                      }));
                    }}
                    disabled={!isEndDateTimeEnabled}
                  />
                  {errors.freezeEndTime && (
                    <div className="text-danger">{errors.freezeEndTime}</div>
                  )}
                </div>
              </div>

              <div className="row dNone">
                <div className="mb-3 col-8 col-lg-4">
                  <label htmlFor="loginDate" className="form-label">
                    {selection === "Login"
                      ? "Login Start Date"
                      : "Issuance Start Date"}
                  </label>
                  <input
                    type="date"
                    id="loginDate"
                    className="form-control"
                    value={loginDate}
                    onChange={(e) => {
                      setLoginDate(e.target.value);
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        loginDate: "",
                      })); // Clear the error
                    }}
                    min={freezeStartDate || minDate}
                    max={freezeEndDate}
                  />
                  {errors.freezeEndTime && (
                    <div className="text-danger">{errors.loginDate}</div>
                  )}
                </div>

                <div className="mb-3 col-4 col-lg-2">
                  <div className="hideLable">hide</div>
                  <input
                    type="time"
                    id="loginTime"
                    className="form-control"
                    value={loginTime}
                    onChange={(e) => {
                      setLoginTime(e.target.value);
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        loginTime: "",
                      })); // Clear the error
                    }}
                  />
                  {errors.freezeEndTime && (
                    <div className="text-danger">{errors.loginTime}</div>
                  )}
                </div>
                <div className="row">
                  <div className="mb-3 col-6 col-lg-6">
                    {errors.global && (
                      <div className="text-danger">{errors.global}</div>
                    )}
                  </div>
                </div>
              </div>

              {/* <button
                type="button"
                className="custom-button col-2"
                onClick={handleSave}
              >
                Save
              </button> */}
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default FreezeDates;
